export enum ConstantsEnum {
  CURRENCY = "EUR",
  USER_TYPE = "private",
  PARTY_TYPE = "seller",
  EMAIL_REGEX = "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"
}


